module.exports = __webpack_public_path__ + "static/media/epub-example-bottom.890363c4.png";